import { ReactNode } from "react";

import { IntercomWidget } from "@/components/common/intercom";
import { CareEligibilityContextProvider } from "@/contexts/careEligibilityContext";
import { CartContextProvider } from "@/contexts/cartContextLoader";
import { ChatProvider } from "@/contexts/chatContext";
import { ConsultsContextProvider } from "@/contexts/consultsContextLoader";
import { LatestReadyTestContextProvider } from "@/contexts/latestReadyTestContext";
import { OrdersContextProvider } from "@/contexts/ordersContextLoader";
import { ProductsContextProvider } from "@/contexts/productsContextLoader";
import { SubscriptionContextProvider } from "@/contexts/subscriptionContextLoader";
import { TransparentCareTreatmentsProvider } from "@/contexts/transparentCareTreatmentsContext";

interface AppProvidersProps {
  isAuthenticated: boolean;
  children: ReactNode;
}

export const AppProviders = ({
  isAuthenticated,
  children,
}: AppProvidersProps) => {
  return (
    <ChatProvider>
      <IntercomWidget>
        <LatestReadyTestContextProvider isAuthenticated={isAuthenticated}>
          <ConsultsContextProvider isAuthenticated={isAuthenticated}>
            <SubscriptionContextProvider isAuthenticated={isAuthenticated}>
              <ProductsContextProvider>
                <CartContextProvider isAuthenticated={isAuthenticated}>
                  <CareEligibilityContextProvider>
                    <TransparentCareTreatmentsProvider>
                      <OrdersContextProvider isAuthenticated={isAuthenticated}>
                        {children}
                      </OrdersContextProvider>
                    </TransparentCareTreatmentsProvider>
                  </CareEligibilityContextProvider>
                </CartContextProvider>
              </ProductsContextProvider>
            </SubscriptionContextProvider>
          </ConsultsContextProvider>
        </LatestReadyTestContextProvider>
      </IntercomWidget>
    </ChatProvider>
  );
};
